var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostEffective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:lock-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9543 45.375C12.8669 45.375 11.9363 45.0081 11.1626 44.2744C10.3888 43.5406 10.0013 42.6575 10 41.625V22.875C10 21.8437 10.3875 20.9612 11.1626 20.2275C11.9376 19.4937 12.8682 19.1262 13.9543 19.125H15.9314V15.375C15.9314 12.7812 16.8956 10.5706 18.824 8.74313C20.7523 6.91563 23.0834 6.00125 25.8171 6C28.5508 5.99875 30.8826 6.91313 32.8122 8.74313C34.7419 10.5731 35.7055 12.7837 35.7028 15.375V19.125H37.68C38.7674 19.125 39.6986 19.4925 40.4737 20.2275C41.2487 20.9625 41.6356 21.845 41.6342 22.875V41.625C41.6342 42.6562 41.2474 43.5394 40.4737 44.2744C39.6999 45.0094 38.7687 45.3762 37.68 45.375H13.9543ZM13.9543 41.625H37.68V22.875H13.9543V41.625ZM25.8171 36C26.9045 36 27.8358 35.6331 28.6108 34.8994C29.3859 34.1656 29.7727 33.2825 29.7714 32.25C29.7701 31.2175 29.3832 30.335 28.6108 29.6025C27.8384 28.87 26.9072 28.5025 25.8171 28.5C24.7271 28.4975 23.7965 28.865 23.0254 29.6025C22.2543 30.34 21.8668 31.2225 21.8628 32.25C21.8589 33.2775 22.2464 34.1606 23.0254 34.8994C23.8044 35.6381 24.735 36.005 25.8171 36ZM19.8857 19.125H31.7485V15.375C31.7485 13.8125 31.1719 12.4844 30.0185 11.3906C28.8652 10.2969 27.4647 9.75 25.8171 9.75C24.1695 9.75 22.769 10.2969 21.6157 11.3906C20.4624 12.4844 19.8857 13.8125 19.8857 15.375V19.125Z",
    fill: "#2CAB93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEffective);
export default __webpack_public_path__ + "static/media/costEffective.a6452338ddae9de7e0ad929c21fbfc3c.svg";
export { ForwardRef as ReactComponent };